module.exports = __webpack_public_path__ + "static/media/Version.b49b2235.txt";


//////////////////
// WEBPACK FOOTER
// ./src/Version.txt
// module id = 126
// module chunks = 1